var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('inactivity-time-modal',{attrs:{"value":true,"time-init":_vm.timeInitChronometer},on:{"finishSession":_vm.signOut,"continueSession":_vm.handleContinueSession}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }